import { render } from "./SectionULU.vue?vue&type=template&id=2432212d"
import script from "./SectionULU.vue?vue&type=script&lang=js"
export * from "./SectionULU.vue?vue&type=script&lang=js"

import "./SectionULU.vue?vue&type=style&index=0&id=2432212d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__